var LOCAL_STORAGE_WISHLIST_KEY = 'orizzonte-wishlist';
var LOCAL_STORAGE_DELIMITER = ',';
var BUTTON_ACTIVE_CLASS = 'active';
var GRID_LOADED_CLASS = 'loaded';

var selectors = {
  button: '[button-wishlist]',
  grid: '[grid-wishlist]',
};

var negozi_ritiro_elenco = {};

    negozi_ritiro_elenco['DPV_00002'] = 'Cisterna - Via Appia Nord 4912';
    negozi_ritiro_elenco['DPV_01001'] = 'Frosinone - Via Monti Lepini 212';
    negozi_ritiro_elenco['DPV_01002'] = 'Ferentino - Via Casilina km 77';
    negozi_ritiro_elenco['DPV_02001'] = 'Fondi - Via Appia Lato Roma 592';
    negozi_ritiro_elenco['DPV_02002'] = 'Latina fronte Plasmon - Via Pontina km 80';
    negozi_ritiro_elenco['DPV_02003'] = 'Sabaudia - Via Enzo Ferrari 4';
    negozi_ritiro_elenco['DPV_03001'] = 'Terracina - Via Badino 227';
    negozi_ritiro_elenco['DPV_03002'] = 'Latina via Isonzo - Via Isonzo 155';
    negozi_ritiro_elenco['DPV_04001'] = 'Latina Piccarello - via Capograssa 4';
    negozi_ritiro_elenco['DPV_04002'] = 'Via Aurelia Km 42+000 (angolo via. F. Morella)';
    negozi_ritiro_elenco['DPV_05001'] = 'Priverno - SP Marittima';
    negozi_ritiro_elenco['DPV_05002'] = 'Pontinia - Via Italia 76';
    negozi_ritiro_elenco['DPV_05003'] = 'Guidonia Tiburtino Shopping Center';
    negozi_ritiro_elenco['DPV_0F001'] = 'Roma Prenestina - Via Prenestina Nuova 54';
    negozi_ritiro_elenco['DPV_0F002'] = 'Roma Collatina - Via Collatina 148';
    negozi_ritiro_elenco['DPV_0G001'] = 'Castel Romano - Via del Ponte di Piscina Cupa 4';
    negozi_ritiro_elenco['DPV_0G002'] = 'Anzio - Via della cannuccia 123';
    negozi_ritiro_elenco['DPV_0H001'] = 'Acilia - Via di Macchia Saponara 84';
    negozi_ritiro_elenco['DPV_0H002'] = 'Dragona - Via Padre Corrado del Lauro 59';
    negozi_ritiro_elenco['DPV_0I001'] = 'Terracina Pontina - Via Pontina km 106,500';
    negozi_ritiro_elenco['DPV_0L001'] = 'Sezze Scalo - Via del Murillo 9';
    negozi_ritiro_elenco['DPV_0M001'] = 'Cassino – Via Ausonia km. 2,1'; 

document.addEventListener('DOMContentLoaded', function () {
  initButtons();
  initGrid();
});

document.addEventListener('shopify-wishlist:updated', function (event) {
  initGrid();
});

document.addEventListener('shopify-wishlist:init-product-grid', function (event) {
});

document.addEventListener('shopify-wishlist:init-buttons', function (event) {
});

var setupGrid = function (grid) {
  var wishlist = getWishlist();
  var requests = wishlist.map(function (handle) {
    var productTileTemplateUrl = '/products/' + handle + '?view=card';
    return fetch(productTileTemplateUrl).then(function (res) {
      return res.text();
    });
  });
  Promise.all(requests).then(function (responses) {
    var wishlistProductCards = responses.join('');
    grid.innerHTML = wishlistProductCards;
    grid.classList.add(GRID_LOADED_CLASS);
    initButtons();

    var event = new CustomEvent('shopify-wishlist:init-product-grid', {
      detail: { wishlist: wishlist }
    });
    document.dispatchEvent(event);
  });
};

var setupButtons = function (buttons) {
  buttons.forEach(function (button) {
    //console.log("setupButtons buttons.forEach", button);
    var productHandle = button.dataset.productHandle || false;
    var productNegozio = button.dataset.negozio || false;
    var variante_attuale_disponibile_wish = false;
    let data_ritiro_val = button.getAttribute('data-product-ritiro');
    //console.log("setupButtons buttons.forEach data_ritiro_val", data_ritiro_val);
    if (data_ritiro_val == "true")
      variante_attuale_disponibile_wish = true;
    
    //console.log("setupButtons buttons.forEach variante_attuale_disponibile_wish", variante_attuale_disponibile_wish);
    
    if (!productHandle) return console.error('[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
    if (wishlistContains(productNegozio + '--' + productHandle)) button.classList.add(BUTTON_ACTIVE_CLASS);
    button.addEventListener('click', function () {
      updateWishlist(productHandle, productNegozio, variante_attuale_disponibile_wish);
      button.classList.toggle(BUTTON_ACTIVE_CLASS);
    });
  });
};

var initGrid = function () {
  var grid = document.querySelector(selectors.grid) || false;
  if (grid) setupGrid(grid);
};

var initButtons = function () {
  var buttons = document.querySelectorAll(selectors.button) || [];
  if (buttons.length) setupButtons(buttons);
  else return;
  var event = new CustomEvent('shopify-wishlist:init-buttons', {
    detail: { wishlist: getWishlist() }
  });
  document.dispatchEvent(event);
};

var getWishlist = function () {
  var wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  //if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
  if (wishlist) return JSON.parse(wishlist);
  return [];
};

var setWishlist = function (array) {
  //var wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, JSON.stringify(array));
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);

  var totale = 0;
  array.forEach(element => {
    totale += element.qta;
  });
  $('#counter_wish').html(totale);
  
  var event = new CustomEvent('shopify-wishlist:updated', {
    detail: { wishlist: array }
  });
  document.dispatchEvent(event);

  return array;
};

var updateWishlist = function (handle, negozio, variante_attuale_disponibile_wish = false) {
  var wishlist = getWishlist();
  var indexInWishlist = null; //wishlist.indexOf(negozio + '--' + handle); 
  var newwishlist = [];
  
    console.log("updateWishlist",handle, negozio, variante_attuale_disponibile_wish);
  
  wishlist.forEach(element => {
    if (element.key == negozio + '--' + handle){
       indexInWishlist = element; 
    }
    else{
      newwishlist.push(element);
    }
  });
  if (indexInWishlist == null) {
    var featured_image_str = JSON.parse(featured_image).replaceAll('\"', '');
    
    var val_product_negozio = { 
      key: negozio + '--' + handle, 
      handle: handle, 
      negozio: negozio, 
      qta: 1, 
      prodprice: prodprice, 
      prodtitle: prodtitle, 
      negozio_des: negozi_ritiro_elenco[negozio], 
      prodvendor: prodvendor, 
      featured_image: featured_image_str, 
      codice_orizzonte: codice_orizzonte,
      variante_attuale_disponibile: variante_attuale_disponibile_wish};
    
    wishlist.push(val_product_negozio);
  }
  else{
    wishlist = newwishlist;
  }
    
  var totale = 0;
  wishlist.forEach(element => {
    totale += element.qta;
  });
  $('#counter_wish').html(totale);
  
  return setWishlist(wishlist);
}; 

var wishlistContains = function (handle) {
  var wishlist = getWishlist();
  var indexInWishlist = null; 
  wishlist.forEach(element => {
    if (element.key == handle){
       indexInWishlist = element; 
       return;
    }
  });
  return indexInWishlist != null;
};

var resetWishlist = function () {
  $('#counter_wish').html(0);
  return setWishlist([]);
};